import styled from "styled-components/macro"
import { Link } from "react-router-dom"
import Color from "../../../constants/Color"

export const SectionContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 16px;
  border-bottom: 1px solid #f5f5f5;
  background: ${({ bg }) => (bg ? Color.gray100 : "")};
  @media (min-width: 1280px) {
    padding-top: 18px;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
`

export const ScrollerContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding-top: 18px;
  padding-bottom: 24px;
  scroll-behavior: smooth;
  scrollbar-width: thin;

  @media (min-width: 768px) {
    &::-webkit-scrollbar {
      width: 4px;
      height: 8px;
      top: 100px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
      cursor: pointer;
      background-color: rgb(212, 212, 212);
      border-radius: 4px;
    }
  }

  @media (min-width: 1280px) {
    padding-bottom: 32px;
  }
`

export const Head = styled.div`
  width: 100%;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 640px) {
    padding: 0 0;
  }
`
export const Left = styled.div`
  /* flex: 1; */
  display: flex;
  align-items: center;
`
export const Right = styled.div`
  /* flex: 1; */
`

export const Title = styled.h2`
  font-size: 18px;
  margin-right: 6px;
  margin-right: 8px;

  @media (min-width: 1024px) {
    font-size: 24px;

    & i {
      font-size: 26px;
    }
  }
`

export const Count = styled.h2`
  font-size: 16px;
  padding: 2px 10px;
  margin: 0 10px;
  color: ${Color.gray100};
  background: ${Color.gray900};
  border-radius: 4px;

  @media (min-width: 1024px) {
    font-size: 17px;
  }
`
export const ViewAll = styled(Link)`
  color: ${Color.gray800};
  text-decoration: none;
`

export const Body = styled.div`
  position: relative;
  width: 100%;
`
